import { ContentButton } from '../content/button';
import { ContentIconLinkList } from '../content/icon-link-list';
import { InternIconLink } from '../intern/icon-link';
import { HeaderButtonList } from './button-list';

/**
 * Model definition for Bar
 */
export interface HeaderBar {
  __component: 'header.bar';
  id: string;
  level1Navigation?: HeaderButtonList;
  level2Navigation?: HeaderButtonList;
  level3Navigation?: HeaderButtonList;
  accessibilityLinks?: ContentIconLinkList;
  searchButton?: InternIconLink;
  button?: ContentButton;
  menuButton?: InternIconLink;
  logoUrl?: string;
  flyoutLogoUrl?: string;
  baseUrl?: string;
}

export function isHeaderBar(obj: { __component?: string }): obj is HeaderBar {
  return obj.__component === 'header.bar';
}
